import React from 'react'
import QrCodeCard from './QrCodeCard'

const QrCodeDialog = ({ cardType, dialogOpen, handleCloseDialog }) => {

    // console.log("dialog type",cardType);
    return (
        <div className='qr-dialog-containre'>
            <div className="dialogue-overlay" style={{ display: dialogOpen ? 'block' : 'none' }} onClick={() => handleCloseDialog(cardType)}>
                <div className='Scanner-outline-preview'>
                    <div className='Displaying-QR'>
                        {/* <span className='d-block text-center'>Scan me</span> */}
                        <div className={"qrCodeContainer"}>
                            <QrCodeCard CARDNAME_id={cardType} />
                        </div>
                        <span className='d-block text-center'>Scan to preview</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QrCodeDialog